var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Take_photo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_24_icon_container",
    "data-name": "24 icon container",
    width: 24,
    height: 24,
    fill: "#1791ea",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "take_photo-2",
    "data-name": "take photo",
    d: "M19.533,14.742H17.517l-.257-.8a1.523,1.523,0,0,0-1.729-1.113H10.59a1.521,1.521,0,0,0-1.727,1.107l-.259.81H6.656A2.039,2.039,0,0,0,4.88,16.8v8.5a1.776,1.776,0,0,0,1.775,1.775H19.532a1.776,1.776,0,0,0,1.775-1.775V16.8a2.038,2.038,0,0,0-1.774-2.055Zm.343,10.216a.622.622,0,0,1-.621.621H6.864a.622.622,0,0,1-.621-.621V16.8a.622.622,0,0,1,.621-.621h2.16a.578.578,0,0,0,.55-.4l.39-1.217c.083-.27.092-.3.626-.3h4.941c.534,0,.543.028.628.305l.388,1.21a.578.578,0,0,0,.55.4h2.16a.622.622,0,0,1,.621.621Zm-6.816-8.194a4.057,4.057,0,1,0,4.057,4.057,4.061,4.061,0,0,0-4.057-4.057Zm0,6.96a2.9,2.9,0,1,1,2.9-2.9A2.907,2.907,0,0,1,13.059,23.724Z",
    transform: "translate(-1.089 -8.105)",
    fill: "#1791ea"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/Take_photo.1488f9ce.svg";
export { ForwardRef as ReactComponent };